import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/services/consulting/ConsultingClient.tsx");
